export default __webpack_public_path__ + "cfb5e8b4395873227580250d6a93cde8.png";